import { gql } from '@apollo/client';

export const CREATE_STUDIO = gql`
  mutation CreateStudio($input: CreateStudioInput!, $condition: ModelStudioConditionInput) {
    createStudio(input: $input, condition: $condition) {
      id
      StudioName
      images
      studioLocation
      pricePerHour
      image
      description
      userID
      studioTypes
      tagValues
      studioSize
      numberOfPeople
      amenities
      city
      postcode
      country
      approxLatitude
      approxLongitude
      locationLabel
      locationPrecision
      minNumberOfHours
      pricingMode
      tieredPricing {
        minPersons
        maxPersons
        pricePerHour
      }
      packages {
        id
        name
        durationHours
        prices {
          minPersons
          maxPersons
          price
        }
      }
      discountRules {
        minHours
        discountType
        discountValue
      }
      weekendSurcharge {
        saturdayEnabled
        saturdaySurchargeType
        saturdaySurchargeValue
        sundayEnabled
        sundaySurchargeType
        sundaySurchargeValue
      }
      extraFees {
        id
        name
        amount
      }
      productionAreaSize
      cancellationPolicy
      houseRules {
        smokingAllowed
        alcoholAllowed
        foodAllowed
        equipmentChangesAllowed
        pyrotechnicsAllowed
        glitterConfettiAllowed
        adultContentAllowed
        fogMachineAllowed
        customRules
      }
      tags {
        items {
          id
          studioId
          tagId
          tag {
            id
            name
          }
        }
        nextToken
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const CREATE_AVAILABILITY = gql`
  mutation CreateAvailability($input: CreateAvailabilityInput!, $condition: ModelAvailabilityConditionInput) {
    createAvailability(input: $input, condition: $condition) {
      id
      studioID
      dayOfWeek
      startTime
      endTime
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const CREATE_STUDIO_EQUIPMENT = gql`
  mutation CreateStudioEquipment($input: CreateStudioEquipmentInput!, $condition: ModelStudioEquipmentConditionInput) {
    createStudioEquipment(input: $input, condition: $condition) {
      id
      studioID
      category
      items {
        id
        name
        count
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const UPDATE_STUDIO_EQUIPMENT = gql`
  mutation UpdateStudioEquipment($input: UpdateStudioEquipmentInput!, $condition: ModelStudioEquipmentConditionInput) {
    updateStudioEquipment(input: $input, condition: $condition) {
      id
      studioID
      category
      items {
        id
        name
        count
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const DELETE_STUDIO_EQUIPMENT = gql`
  mutation DeleteStudioEquipment($input: DeleteStudioEquipmentInput!, $condition: ModelStudioEquipmentConditionInput) {
    deleteStudioEquipment(input: $input, condition: $condition) {
      id
      __typename
    }
  }
`;

export const DELETE_AVAILABILITY = gql`
  mutation DeleteAvailability($input: DeleteAvailabilityInput!) {
    deleteAvailability(input: $input) {
      id
      __typename
    }
  }
`;

export const CREATE_PAID_EQUIPMENT_ITEM = gql`
  mutation CreatePaidEquipmentItem($input: CreatePaidEquipmentItemInput!, $condition: ModelPaidEquipmentItemConditionInput) {
    createPaidEquipmentItem(input: $input, condition: $condition) {
      id
      studioID
      category
      name
      price
      quantity
      description
      imageKey
      sortOrder
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const UPDATE_PAID_EQUIPMENT_ITEM = gql`
  mutation UpdatePaidEquipmentItem($input: UpdatePaidEquipmentItemInput!, $condition: ModelPaidEquipmentItemConditionInput) {
    updatePaidEquipmentItem(input: $input, condition: $condition) {
      id
      studioID
      category
      name
      price
      quantity
      description
      imageKey
      sortOrder
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const DELETE_PAID_EQUIPMENT_ITEM = gql`
  mutation DeletePaidEquipmentItem($input: DeletePaidEquipmentItemInput!, $condition: ModelPaidEquipmentItemConditionInput) {
    deletePaidEquipmentItem(input: $input, condition: $condition) {
      id
      __typename
    }
  }
`;

export const DELETE_STUDIO = gql`
  mutation DeleteStudio($input: DeleteStudioInput!) {
    deleteStudio(input: $input) {
      id
      StudioName
      __typename
    }
  }
`;

export const GET_TAG_BY_NAME = gql`
  query ListTags($name: String!) {
    listTags(filter: { name: { eq: $name } }) {
      items {
        id
        name
      }
    }
  }
`;

export const CREATE_TAG = gql`
  mutation CreateTag($input: CreateTagInput!) {
    createTag(input: $input) {
      id
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const CREATE_STUDIO_TAG = gql`
  mutation CreateStudioTag($input: CreateStudioTagInput!) {
    createStudioTag(input: $input) {
      id
      studioId
      tagId
      studio {
        id
      }
      tag {
        id
        name
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const DELETE_STUDIO_TAG_LINK = gql`
  mutation DeleteStudioTagLink($input: DeleteStudioTagInput!) {
    deleteStudioTag(input: $input) {
      id
      __typename
    }
  }
`;

export const DELETE_STUDIO_TAG = gql`
  mutation DeleteTag($input: DeleteTagInput!, $condition: ModelTagConditionInput) {
    deleteTag(input: $input, condition: $condition) {
      id
      name
      studios {
        items {
          id
          studioId
          tagId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
